const FifthTable = () => {
    return (
        <div className="floorplan-table">
                            <h4>Business / Cellular / Meetings</h4>
                            <div className='table'>
                                <div className='row'>
                                    <div className='cell'>
                                        <h5>Workstations</h5>
                                    </div>
                                    <div className='cell'>
                                        <h5>64</h5>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='cell'>
                                        <h5>Meeting / Training Rooms</h5>
                                    </div>
                                    <div className='cell'>
                                        <h5>3</h5>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='cell'>
                                        <h5>Collaboration Spaces 3</h5>
                                    </div>
                                    <div className='cell'>
                                        <h5>3</h5>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='cell'>
                                        <h5>Breakout Spaces 3</h5>
                                    </div>
                                    <div className='cell'>
                                        <h5>3</h5>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='cell'>
                                        <h5>Phone Pod</h5>
                                    </div>
                                    <div className='cell'>
                                        <h5>1</h5>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='cell'>
                                        <h5>Reception</h5>
                                    </div>
                                    <div className='cell'>
                                        <h5>1</h5>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='cell'>
                                        <h5>Teapoint</h5>
                                    </div>
                                    <div className='cell'>
                                        <h5>1</h5>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='cell'>
                                        <h5>Area</h5>
                                    </div>
                                    <div className='cell'>
                                        <h5>6,167 SQ FT / 573 SQ M</h5>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='cell'>
                                        <h5>Area / Person</h5>
                                    </div>
                                    <div className='cell'>
                                        <h5>10 SQ M / Person</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
    );
    }
export default FifthTable;